import { useLocation, useParams } from 'react-router-dom';

const usePathname = (removeParams = false) => {
	const location = useLocation();
	const params = useParams();

	let path = location.pathname;

	if (removeParams) {
		Object.values(params).forEach((paramValue) => {
			path = path.replace(`/${paramValue}`, '');
		});
	}

	return path;
};

export default usePathname;
